module.exports = __webpack_public_path__ + "media/images/pc/accessories/men/men_02-6bfc2e0a588db4d7654ea87fac421c5e.jpg";